import i from './admin-payment-history.container';

export default i;
